import { FC, ReactNode } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { DialogProps } from "@material-ui/core/Dialog";
import {
  ArrowBack as ArrowBackIcon,
  Close as CloseIcon,
} from "@material-ui/icons";

import theme from "theme";

const useStyles = makeStyles(theme => ({
  paper: {
    margin: theme.spacing(4),
    "@media (max-width: 400px)": {
      width: "100%",
    },
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    padding: theme.spacing(0.625),
    "& > div": {
      display: "flex",
      flexDirection: "row",
      flex: 1,
    },
    "& > div:nth-last-of-type(2)": {
      justifyContent: "flex-start",
    },
    "& > div:nth-last-of-type(1)": {
      justifyContent: "flex-end",
    },
    "& > div:first-of-type:nth-last-of-type(1)": {
      justifyContent: "flex-end",
    },
  },
  title: {},
  content: {
    padding: theme.spacing(2, 4),
  },
}));

interface OwnProps {
  title?: string | ReactNode;
  children: ReactNode;
  onBack?: () => void;
  closeButtonText?: string;
  hideCloseButton?: boolean;
}

export type ModalProps = Omit<DialogProps, keyof OwnProps> & OwnProps;

const Modal: FC<ModalProps> = ({
  title,
  children,
  onBack,
  closeButtonText,
  hideCloseButton,
  maxWidth = "xs",
  fullWidth = true,
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <Dialog
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      classes={{ paper: classes.paper }}
      {...restProps}
    >
      {restProps.open && (
        <>
          <Box className={classes.actions}>
            {onBack && (
              <div>
                <IconButton onClick={onBack}>
                  <ArrowBackIcon />
                </IconButton>
              </div>
            )}
            {!hideCloseButton && (
              <div>
                <IconButton
                  id="btn-close-modal"
                  onClick={e => restProps.onClose(e, "backdropClick")}
                  aria-label="close-modal"
                >
                  <CloseIcon />
                </IconButton>
              </div>
            )}
          </Box>
          {title && (
            <Box className={classes.title}>
              <Typography component="div">
                <Box
                  fontSize={20}
                  fontWeight={theme.typography.fontWeightMedium}
                  textAlign="center"
                  paddingLeft={4}
                  paddingRight={4}
                >
                  {title}
                </Box>
              </Typography>
            </Box>
          )}
          <Box className={classes.content}>{children}</Box>
          {!!closeButtonText && (
            <DialogActions>
              <Button
                onClick={(e: any) => restProps.onClose(e, "backdropClick")}
                variant="text"
              >
                {closeButtonText}
              </Button>
            </DialogActions>
          )}
        </>
      )}
    </Dialog>
  );
};

export default Modal;
